import { POWERED_BY, LINEAGE_FOOTER } from '../version';

interface LoginPageProps {
  onLogin: () => void;
}

export function LoginPage({ onLogin }: LoginPageProps) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 100%)'
    }}>
      <div className="card" style={{ 
        maxWidth: 400, 
        width: '100%',
        margin: '0 var(--spacing-md)',
        textAlign: 'center'
      }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          marginBottom: 'var(--spacing-lg)' 
        }}>
          <img 
            src="/doyle-logo.png" 
            alt="Doyle Security Systems"
            style={{
              width: 80,
              height: 80,
              objectFit: 'contain'
            }}
          />
        </div>
        
        <h1 style={{ marginBottom: 'var(--spacing-xs)' }}>Doyle Vault</h1>
        <div style={{
          fontSize: '0.75rem',
          color: 'var(--text-muted)',
          marginBottom: 'var(--spacing-sm)'
        }}>{POWERED_BY}</div>
        <p style={{
          color: 'var(--text-secondary)',
          marginBottom: 'var(--spacing-xl)',
          fontSize: '0.875rem'
        }}>
          Ask anything about the systems you service.
        </p>

        <button 
          className="btn-primary" 
          onClick={onLogin}
          style={{ width: '100%', padding: 'var(--spacing-md)' }}
        >
          <svg width="20" height="20" viewBox="0 0 23 23" fill="currentColor">
            <path d="M0 0h10.931v10.931H0V0zm12.069 0H23v10.931H12.069V0zM0 12.069h10.931V23H0V12.069zm12.069 0H23V23H12.069V12.069z"/>
          </svg>
          Sign in with Microsoft
        </button>

        <div style={{ 
          marginTop: 'var(--spacing-lg)',
          padding: 'var(--spacing-md)',
          background: 'var(--bg-tertiary)',
          borderRadius: 'var(--radius-md)',
          fontSize: '0.75rem',
          color: 'var(--text-muted)'
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 'var(--spacing-xs)', 
            justifyContent: 'center',
            marginBottom: 'var(--spacing-xs)'
          }}>
            <div style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: 'var(--doyle-red)'
            }} />
            <div style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: 'var(--doyle-green)'
            }} />
            <div style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: 'var(--doyle-blue)'
            }} />
            <div style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: 'var(--doyle-purple)'
            }} />
          </div>
          <div>Doyle Security Systems • Since 1919</div>
        </div>

        {/* Lineage line — the V in DevGPT always stood for Vault. */}
        <div style={{
          marginTop: 'var(--spacing-md)',
          fontSize: '0.6875rem',
          color: 'var(--text-muted)'
        }}>
          {LINEAGE_FOOTER}
        </div>
      </div>
    </div>
  );
}
